import Toastify from 'toastify-js'
import localStorageTools from '@/util/localStorageTools.js'

// https://stackoverflow.com/questions/985272/selecting-text-in-an-element-akin-to-highlighting-with-your-mouse
function selectText(node) {
    node = document.getElementById(node);

    if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    } else {
        console.warn("Could not select text in node: Unsupported browser.");
    }
}

function showNotification(){
    Toastify({
        text: "CSS Copied to Clipboard",
        duration: 3000,
        newWindow: true,
        gravity: "top", // `top` or `bottom`
        position: 'right', // `left`, `center` or `right`
        backgroundColor: "repeating-linear-gradient(45deg, rgba(24, 24, 24, 0.3) 0px, rgba(24, 24, 24, 0.3) 143px,rgba(62, 62, 62, 0.3) 143px, rgba(62, 62, 62, 0.3) 286px),repeating-linear-gradient(135deg, rgba(131, 131, 131, 0.11) 0px, rgba(131, 131, 131, 0.11) 137px,rgba(249, 249, 249, 0.11) 137px, rgba(249, 249, 249, 0.11) 274px),linear-gradient(90deg, rgb(152, 246, 30),rgb(133, 254, 10))",
        stopOnFocus: true, // Prevents dismissing of toast on hover
        onClick: function(){} // Callback after click
    }).showToast(); 
}

function registerGradientDownload(gid){
    gtag('event', 'download', {
        'event_category': 'gradient',
        'event_label': gid,
        'event_value': 1
    });
}

let totalDownloads = 0;

const copyGradientToClipboard = function(text, gid){

    totalDownloads++;
    checkForFeedbackModal();

    // Set content to text
    let codeContainer = document.querySelector('#cssCode');
    codeContainer.innerHTML = text;
    selectText('cssCode')
    document.execCommand('copy')
    codeContainer.innerHTML = ''
    showNotification();
    registerGradientDownload(gid);
}

function checkForFeedbackModal(){
    if(localStorageTools.localStorageAvailable()){
        let myStorage = window.localStorage
        let subscriber = myStorage.getItem('subscriber')
        if(subscriber == 'true') return;
    }

    if(totalDownloads == 1) window.setTimeout(openFeedbackModal, 3000);
}

const openFeedbackModal = function(){
    let modal = document.getElementById("feedbackModal");

    let closeButtons = modal.getElementsByClassName('close-modal');

    for(let i=0;i<closeButtons.length;i++){
        closeButtons[i].onclick = function(){
            modal.style.display = "none"
        }
    }

    modal.style.display = "block"
    modal.classList.add('show')
}

export default {
    copyGradientToClipboard
}